import { useFormatters } from '../format/use-formatters';
import { baseSportPriceCents, extraSportPriceCents, freeScans, monthlyScans } from './plan';

export const usePlanPrices = () => {
  const { formatCurrency } = useFormatters();
  return {
    base: formatCurrency(baseSportPriceCents / 100),
    additional: formatCurrency(extraSportPriceCents / 100),
    two: formatCurrency((baseSportPriceCents + extraSportPriceCents) / 100),
    three: formatCurrency((baseSportPriceCents + 2 * extraSportPriceCents) / 100),
    freeScans,
    monthlyScans,
  };
};
